interface JwtPayload {
	id?: string;
	RoleId?: string | number;
	role?: number | string;
}

export const getRoleIdFromToken = (token: string | null): number | null => {
	if (!token) return null;

	try {
		const payloadBase64 = token.split(".")[1];
		if (!payloadBase64) return null;

		const payloadJson = atob(payloadBase64.replace(/-/g, "+").replace(/_/g, "/"));
		const payload: JwtPayload = JSON.parse(payloadJson);

		const roleId = payload.RoleId;

		if (typeof roleId === "number") {
			return roleId;
		}

		if (typeof roleId === "string" && !isNaN(parseInt(roleId))) {
			return parseInt(roleId);
		}

		return null;
	} catch (error) {
		console.error("Invalid JWT token:", error);
		return null;
	}
};

export const isAuthenticated = (): boolean => {
	return !!sessionStorage.getItem("Token");
};
